import { useRegister } from "./RegisterContext";
import { useTranslation } from "react-i18next";



const AGENT_STATUSES = [
    "lawyerStatus.fifaAgent",
    "lawyerStatus.faAgent",
    "lawyerStatus.fffAgent",
    "lawyerStatus.frmfAgent",
    "lawyerStatus.figcAgent",
    "lawyerStatus.rfefAgent",
    "lawyerStatus.matchAgent",
    "lawyerStatus.sportsIntermediary",
];

const LEGAL_STATUSES = [
    "lawyerStatus.sportsLawyer",
    "lawyerStatus.sportsJurist",
    "lawyerStatus.legalAdvisor",
];

export default function LawyerVerification() {
    const {
        details,
        verificationData,
        setVerificationData,
    } = useRegister();

    const { t } = useTranslation();

    const statuses = details.statuses || [];

    const agentStatuses = statuses.filter((s) =>
        AGENT_STATUSES.includes(s)
    );

    const legalStatuses = statuses.filter((s) =>
        LEGAL_STATUSES.includes(s)
    );

    const businessStatuses = statuses.filter(
        (s) =>
            !AGENT_STATUSES.includes(s) &&
            !LEGAL_STATUSES.includes(s)
    );

    const handleFile = (e) => {
        const { name, files } = e.target;

        setVerificationData((prev) => ({
            ...prev,
            [name]: files[0],
        }));
    };

    return (
        <div className="verification-wrapper">
            <VerificationInfo
                title={t("lawyerVerification.requiredTitle")}
                text={t("lawyerVerification.requiredText")}
            />

            <div className="verification-content">

                <UploadBox
                    label={t("lawyerVerification.identity")}
                    name="own_id"
                    file={verificationData.own_id}
                    onChange={handleFile}
                />

                {agentStatuses.map((status, index) => (
                    <UploadBox
                        key={status}
                        label={`${t("lawyerVerification.license")} — ${t(status)}`}
                        name={`agent_license_${index + 1}`}
                        file={
                            verificationData[
                            `agent_license_${index + 1}`
                            ]
                        }
                        onChange={handleFile}
                    />
                ))}

                {legalStatuses.length > 0 && (
                    <UploadBox
                        label={t("lawyerVerification.legalCertificate")}
                        name="legal_certificate"
                        file={verificationData.legal_certificate}
                        onChange={handleFile}
                    />
                )}

                {businessStatuses.length > 0 && (
                    <UploadBox
                    label={t("lawyerVerification.businessCertificate")}
                        name="representation_certificate"
                        file={
                            verificationData.representation_certificate
                        }
                        onChange={handleFile}
                    />
                )}

            </div>

            <PrivacyNotice />
        </div>
    );
}

function VerificationInfo({ title, text }) {

    const { t } = useTranslation();


    return (
        <div className="verification-info-card">
            <div className="verification-badge">
                ✓ {t("lawyerVerification.carrerupVerification")}
            </div>

            <h3>{title}</h3>
            <p>{text}</p>
        </div>
    );
}

function PrivacyNotice() {

    const { t } = useTranslation();

    return (
        <div className="verification-privacy">
            🔒 {t("lawyerVerification.privacy")}
        </div>
    );
}

function UploadBox({ label, name, file, onChange }) {
    return (
        <div className="input-wrapper full-width">
            <label className="pdf-upload-label">
                {label}

                <input
                    required
                    type="file"
                    name={name}
                    accept=".pdf,image/*"
                    hidden
                    onChange={onChange}
                />
            </label>

            {file && (
                <div className="pdf-selected">
                    📄 {file.name}
                </div>
            )}
        </div>
    );
}